import React from "react";

import { QuestionnaireRow } from "components/AttachmentForm/Components";
import {
  NVDOptionToggler,
  DatePurchasedOptionsToggler,
  NVD_OPTIONS,
  useSuggestionMap,
} from "components/AttachmentForm/NVDOptionToggles";
import { Input } from "components/Form/FormikControls";
import { Column } from "components/Layout";

export const G0524 = ({ formikProps }) => {
  const suggestedValueMap = useSuggestionMap();
  return (
    <Column>
      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.owned_since_birth" label="1." />
        {formikProps.values.declaration.owned_since_birth ===
          NVD_OPTIONS.NO && (
          <QuestionnaireRow>
            <DatePurchasedOptionsToggler
              name="declaration.owned_since_birth_duration"
              label=""
            />
          </QuestionnaireRow>
        )}
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.veterinary_treatment" label="2." />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.consumed_material_in_withholding_period"
          label="3."
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.fed_feed_containing_animal_fats"
          label="4."
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <Input
          name="declaration.additional_information"
          label="5."
          suggestedValueFieldName={
            suggestedValueMap["declaration.additional_information"]
          }
        />
      </QuestionnaireRow>
    </Column>
  );
};
